import React from "react";
import styled from "styled-components";

const BreadcrumbContainer = styled.nav`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 0;
  margin-bottom: 1rem;
  flex-wrap: wrap;
`;

const BreadcrumbItem = styled.button<{ $isActive?: boolean }>`
  background: none;
  border: none;
  padding: 0;
  font-size: 0.9rem;
  color: ${props => props.$isActive ? "#001f52" : "#666"};
  cursor: pointer;
  transition: color 0.2s ease;
  font-weight: ${props => props.$isActive ? 600 : 400};
  
  .dark-mode & {
    color: ${props => props.$isActive ? "#e0e0e0" : "#999"};
  }
  
  &:hover {
    color: #64da4c;
    
    .dark-mode & {
      color: #64da4c;
    }
  }
`;

const Separator = styled.span`
  color: #999;
  font-size: 0.85rem;
  user-select: none;
  
  .dark-mode & {
    color: #666;
  }
`;

interface BreadcrumbItemData {
  label: string;
  path: string[];
}

interface BreadcrumbProps {
  items: BreadcrumbItemData[];
  onNavigate: (path: string[]) => void;
  categoryName?: string;
}

export default function Breadcrumb({ items, onNavigate, categoryName }: BreadcrumbProps) {
  const handleClick = (index: number) => {
    if (index === -1) {
      onNavigate([]);
    } else {
      onNavigate(items[index].path);
    }
  };

  return (
    <BreadcrumbContainer>
      {categoryName && (
        <>
          <BreadcrumbItem
            onClick={() => handleClick(-1)}
            $isActive={items.length === 0}
          >
            {categoryName}
          </BreadcrumbItem>
          {items.length > 0 && <Separator>{'>'}</Separator>}
        </>
      )}
      {items.map((item, index) => (
        <React.Fragment key={item.path.join('/')}>
          <BreadcrumbItem
            onClick={() => handleClick(index)}
            $isActive={index === items.length - 1}
          >
            {item.label}
          </BreadcrumbItem>
          {index < items.length - 1 && <Separator>{'>'}</Separator>}
        </React.Fragment>
      ))}
    </BreadcrumbContainer>
  );
}
